// Minimal, printable/signable repair-estimate slip. No shop header — just the
// title, estimate number, order number and the full calculation breakdown.

const TYPE_LABELS = {
  new_gold: 'New gold added',
  new_stone: 'New diamond / stone added',
  making: 'Making / labour',
  rhodium: 'Rhodium / polish',
  hallmark: 'Hallmarking',
  wastage: 'Wastage',
  other_charge: 'Other charge',
  old_gold: 'Old gold melt credit',
  removed_stone: 'Removed stone returned value',
  discount: 'Discount',
  other_credit: 'Other credit',
};

const inr = (n) => '\u20B9' + Math.round(Number(n) || 0).toLocaleString('en-IN');
const esc = (s) => String(s == null ? '' : s).replace(/[&<>]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]));

const rows = (list = []) => list.map((r) => {
  const label = esc(r.label || TYPE_LABELS[r.type] || r.type || '');
  const detail = (r.weight && r.rate) ? `${r.weight} g \u00D7 ${inr(r.rate)}/g` : '';
  return `<tr><td>${label}</td><td class="d">${detail}</td><td class="a">${inr(r.amount)}</td></tr>`;
}).join('');

export function printRepairEstimate(est) {
  if (!est) return;
  const date = est.confirmed_at || est.created_at;
  const dateStr = date ? new Date(date).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' }) : '';
  const chargesRows = rows(est.charges) || '<tr><td colspan="3" class="muted">—</td></tr>';
  const creditsRows = (est.credits && est.credits.length) ? rows(est.credits) : '<tr><td colspan="3" class="muted">None</td></tr>';
  const verdict = est.customer_pays ? 'Customer pays' : 'We refund';

  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>Repair Estimate ${esc(est.estimate_number || '')}</title>
  <style>
    * { box-sizing: border-box; }
    body { font-family: -apple-system, Segoe UI, Roboto, Arial, sans-serif; color:#111; margin:0; padding:28px 32px; }
    h1 { font-size:20px; margin:0 0 2px; letter-spacing:.5px; }
    .meta { font-size:12px; color:#444; margin-bottom:16px; }
    .meta b { color:#111; }
    table { width:100%; border-collapse:collapse; margin:6px 0 14px; }
    th { text-align:left; font-size:11px; text-transform:uppercase; letter-spacing:.4px; color:#666; border-bottom:1px solid #ccc; padding:6px 4px; }
    td { font-size:13px; padding:6px 4px; border-bottom:1px solid #eee; }
    td.a, th.a { text-align:right; white-space:nowrap; }
    td.d { color:#666; font-size:12px; }
    .sect { font-size:12px; font-weight:700; text-transform:uppercase; letter-spacing:.5px; margin-top:10px; }
    .sect.chg { color:#047857; }
    .sect.cr { color:#b45309; }
    .totals { margin-top:8px; border-top:2px solid #111; padding-top:8px; }
    .row { display:flex; justify-content:space-between; font-size:13px; padding:3px 0; }
    .row.net { font-size:16px; font-weight:800; border-top:1px solid #ccc; margin-top:4px; padding-top:8px; }
    .muted { color:#999; }
    .sign { margin-top:48px; display:flex; justify-content:space-between; }
    .sign div { width:45%; border-top:1px solid #111; padding-top:6px; font-size:12px; color:#444; text-align:center; }
    .fine { margin-top:22px; font-size:10px; color:#888; }
    @media print { body { padding:12px 16px; } }
  </style></head><body>
    <h1>Repair Estimate</h1>
    <div class="meta">
      Estimate No: <b>${esc(est.estimate_number || '—')}</b>${est.order_number ? ` &nbsp;&middot;&nbsp; Order No: <b>${esc(est.order_number)}</b>` : ''}
      &nbsp;&middot;&nbsp; Date: <b>${esc(dateStr)}</b>
    </div>

    <div class="sect chg">Charges</div>
    <table><thead><tr><th>Item</th><th class="d">Detail</th><th class="a">Amount</th></tr></thead>
      <tbody>${chargesRows}</tbody></table>

    <div class="sect cr">Credits</div>
    <table><thead><tr><th>Item</th><th class="d">Detail</th><th class="a">Amount</th></tr></thead>
      <tbody>${creditsRows}</tbody></table>

    <div class="totals">
      <div class="row"><span>Total charges</span><span>${inr(est.subtotal_charges)}</span></div>
      <div class="row"><span>GST (${est.gst_percent}% on charges)</span><span>+ ${inr(est.gst_amount)}</span></div>
      <div class="row"><span>Charges incl. GST</span><span>${inr(est.charges_with_gst)}</span></div>
      <div class="row"><span>Total credits</span><span>&minus; ${inr(est.subtotal_credits)}</span></div>
      <div class="row net"><span>${verdict}</span><span>${inr(Math.abs(est.net_amount))}</span></div>
    </div>

    <div class="sign"><div>Customer signature</div><div>Authorised signature</div></div>
    <div class="fine">This is an estimate. Final amount may vary with the gold rate on the delivery date.</div>
    <script>window.onload = function(){ window.print(); };</script>
  </body></html>`;

  const w = window.open('', '_blank', 'width=800,height=900');
  if (!w) return;
  w.document.open();
  w.document.write(html);
  w.document.close();
}
